import React from 'react';
import SystemSaveRestorePageView from './system-save-restore-page-view.jsx';

function SystemSaveRestorePageContainer() {
  return <SystemSaveRestorePageView />;
}

export default SystemSaveRestorePageContainer;
